import type { TranscriptUtterance } from '@/client/types.gen'

/**
 * Reconstruct plain text transcript from utterances with optional edits applied.
 *
 * NOTE: Output always uses the "Speaker: text" format (no brackets). If the
 * original transcript used "[Speaker]: text", saving will normalize it to the
 * non-bracket form. This is intentional — the parser accepts both formats on
 * input, but we standardize on the simpler format for consistency.
 *
 * @param utterances Array of transcript utterances
 * @param edits Map of utterance index to edited text (only includes edited utterances)
 * @param speakerEdits Optional map of utterance index to edited speaker name
 * @returns Plain text format: "Speaker: text\nSpeaker: text..."
 */
export function reconstructPlainText(
	utterances: TranscriptUtterance[],
	edits: Map<number, string>,
	speakerEdits?: Map<number, string>
): string {
	return utterances
		.map((u, idx) => {
			const editedText = edits.get(idx)
			const text = editedText !== undefined ? editedText : u.text
			const speaker = speakerEdits?.get(idx) ?? u.speaker
			return `${speaker}: ${text}`
		})
		.join('\n')
}
